var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { BContainer, BRow, BSpinner, BButton } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
import axios from 'axios';
import SearchForm from 'components/ranges/search-form.vue';
import RangeResult from 'components/ranges/range-result.vue';
let RangesSearch = class RangesSearch extends Vue {
    constructor() {
        super(...arguments);
        this.filters = {
            rating: 5,
            price: 'any'
        };
        this.resultsPerLoad = 20;
        this.page = 1;
        this.loading = true;
        this.endOfResults = false;
        this.ranges = [];
        this.debouncedResetSearch = debounce(this.resetSearch, 350);
    }
    resetSearch() {
        this.page = 1;
        this.ranges = [];
        this.endOfResults = false;
        this.loadRanges();
    }
    loadRanges() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.endOfResults) {
                return false;
            }
            this.loading = true;
            let { data } = yield axios.get('/api/materials/moulding/ranges', {
                params: {
                    rating: this.filters.rating,
                    price: this.filters.price,
                    limit: this.resultsPerLoad,
                    page: this.page
                }
            });
            this.ranges.push(...data);
            this.loading = false;
            this.page++;
            this.endOfResults = data.length === 0;
        });
    }
    mounted() {
        this.loadRanges();
    }
};
__decorate([
    Watch('filters', { deep: true })
], RangesSearch.prototype, "debouncedResetSearch", void 0);
RangesSearch = __decorate([
    Component({
        components: {
            BSpinner, BContainer, BRow, BButton,
            SearchForm, RangeResult
        }
    })
], RangesSearch);
export default RangesSearch;
